import { getPasswordValidators, ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { comparePasswords, Validation } from '@ngx-validate/core';
import { Store } from '@ngxs/store';
import { Account } from '@abp/ng.account';

const { required } = Validators;

const PASSWORD_FIELDS = ['newPassword', 'repeatNewPassword'];

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password.component.html',
    exportAs: 'abpChangePasswordForm',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordComponent
  implements OnInit, Account.ChangePasswordComponentInputs, Account.ChangePasswordComponentOutputs
{
  form: FormGroup = this.fb.group({
    password: ['', required],
    newPassword: ['', { validators: [required] }],
    repeatNewPassword: ['', { validators: [required] }],
  },
  {
    validators: [comparePasswords(PASSWORD_FIELDS)],
  });

  inProgress: boolean;

  hideCurrentPassword: boolean = false;

  mapErrorsFn: Validation.MapErrorsFn = (errors, groupErrors, control) => {
    if (PASSWORD_FIELDS.indexOf(String(control.name)) < 0) return errors;
    return errors.concat(groupErrors.filter(({ key }) => key === 'passwordMismatch'));
  };

  constructor(
    private toasterService: ToasterService,
    private injector: Injector,
    private fb: FormBuilder,
    private store: Store,
  ) {}

  ngOnInit(): void {
    const passwordValidations = getPasswordValidators(this.injector);

    this.form.setControl('newPassword', this.fb.control('', [required, ...passwordValidations]));
    this.form.setControl('repeatNewPassword', this.fb.control('', [required, ...passwordValidations]));

    if (this.hideCurrentPassword) {
      this.form.removeControl('password');
    }
  }

  onSubmit() {
    // if (this.form.invalid) return;
    // this.inProgress = true;
    // this.store
    //   .dispatch(
    //     new ChangePassword({
    //       ...(!this.hideCurrentPassword && { currentPassword: this.form.get('password').value }),
    //       newPassword: this.form.get('newPassword').value,
    //     })
    //   )
    //   .pipe(finalize(() => (this.inProgress = false)))
    //   .subscribe({
    //     next: () => {
    //       this.form.reset();
    //       this.toasterService.success('AbpAccount::PasswordChangedMessage', '', {
    //         life: 5000,
    //       });
    //       if (this.hideCurrentPassword) {
    //         this.hideCurrentPassword = false;
    //         this.form.addControl('password', new FormControl('', [required]));
    //       }
    //     },
    //     error: err => {
    //       this.toasterService.error(
    //         err?.error?.error?.message ?? 'AbpAccount::DefaultErrorMessage'
    //       );
    //     },
    //   });
  }
}